import React, { createContext, useReducer, useEffect } from 'react';
import { ADMIN_NAV_SECTIONS } from './constants/navigation';
import { validateAndClearInvalidToken } from './utils';

export const Store = createContext();
const initialState = {
	userInfo: localStorage.getItem('userInfo')
		? JSON.parse(localStorage.getItem('userInfo'))
		: null,
	cart: {
		shippingAddress: localStorage.getItem('shippingAddress')
			? JSON.parse(localStorage.getItem('shippingAddress'))
			: {},
		cartItems: localStorage.getItem('cartItems')
			? JSON.parse(localStorage.getItem('cartItems'))
			: [],
		paymentMethod: localStorage.getItem('paymentMethod')
			? localStorage.getItem('paymentMethod')
			: '',
	},
	tabs: ADMIN_NAV_SECTIONS,
};
function reducer(state, action) {
	switch (action.type) {
	case 'USER_SIGNIN':
		return { ...state, userInfo: action.payload };
	case 'UPDATE_USER_INFO':
		// localStorage.setItem("userInfo", JSON.stringify(action.payload));
		return { ...state, userInfo: action.payload };
	case 'USER_SIGNOUT':
		return {
			...state,
			userInfo: null,
			cart: {
				cartItems: [],
				shippingAddress: {},
				paymentMethod: '',
			},
		};
	case 'SET_TABS':
		return { ...state, tabs: action.payload };
	case 'UPDATE_TABS':
		return { ...state, tabs: action.payload };
	default:
		return state;
	}
}
export function StoreProvider(props) {
	const [state, dispatch] = useReducer(reducer, initialState);
	
	// Validate token on app initialization
	useEffect(() => {
		const validateToken = async () => {
			if (state.userInfo) {
				const isValid = await validateAndClearInvalidToken();
				if (!isValid) {
					// Token was invalid and localStorage was cleared, update state
					dispatch({ type: 'USER_SIGNOUT' });
				}
			}
		};
		validateToken();
	}, []); // Only run on mount
	
	const value = { state, dispatch };
	return <Store.Provider value={value}>{props.children}</Store.Provider>;
}
